<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      append-to-body
      title="发货通知单选择"
      width="1200px">
    <table-select
        ref="tableSelect"
        url="sd/deliveryBillDetails"
        module="basic"
        :filter="filter"
        :columns="columns"
        @select="selectDeliveryBill"
        @reset="resetHandle">
      <template slot="adSearch">
        <el-form ref="form" :inline="true" :model="filter" label-width="95px">
          <el-form-item label="关键字">
            <el-input v-model.trim="filter.filter" placeholder="请输入订单编号" clearable/>
          </el-form-item>
        </el-form>
      </template>
    </table-select>
    <span slot="footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button type="primary" @click="submitHandle">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
  import TableSelect from "@/components/TableSelect.vue";

  export default {
    components: {TableSelect},
    data() {
      return {
        dialogVisible: false,
        selections: [],
        filter: {
          billNo: "",
          materialNo: "",
          materialName: "",
          specification: "",
          customerNo: "",
          customerName: "",
          deliveryBeginDate: "",
          deliveryEndDate: "",
          isDelivery: 10,
        },
        columns: [
          {
            type: "selection",
            width: 60,
            align: "center",
          },
          {
            title: "编号",
            key: "billNo",
            align: "center",
            width: 120,
          },
          {
            title: "销售订单号",
            key: "salesOrderNO",
            align: "center",
            width: 120,
          },
          {
            title: "客户名称",
            key: "customerName",
            minWidth: 180,
          },
          {
            title: "物料编号",
            key: "materialNo",
            width: 120,
          },
          {
            title: "物料名称",
            key: "materialName",
            minWidth: 100,
          },
          {
            title: "规格型号",
            key: "specification",
            minWidth: 180,
          },
          {
            title: "数量",
            key: "quantity",
            width: 80,
            align: "center",
          },
          {
            title: "交货日期",
            key: "deliveryDate",
            width: 120,
            align: "center",
          },
          {
            title: "备注",
            key: "note",
            width: 200,
          },
        ],
      };
    },
    methods: {
      open() {
        this.dialogVisible = true;
        this.$nextTick(() => {
          this.$refs.form.resetFields();
          this.$refs.tableSelect.loadData();
        });
      },

      selectDeliveryBill(selections) {
        this.selections = selections;
      },

      submitHandle() {
        this.$emit("select", this.selections);
        this.dialogVisible = false;
      },

      resetHandle(filter) {
        this.filter = filter;
        this.$nextTick(() => {
          this.$refs.tableSelect.loadData();
        });
      },
    },
  };
</script>

<style>

</style>